import {
  HHLogo,
  HHTypography,
  useHingeHealthSecurityContext,
} from '@hinge-health/react-component-library';
import { Box, ListItem } from '@mui/material';
import Drawer from '@mui/material/Drawer';
import List from '@mui/material/List';
import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';
import { RouteDetails } from '../routes';
import { getRoleProperties } from '../utils/roles';
import { useSplitEnabledRoutes } from '../utils/use-split-enabled-routes';
import { MenuItem } from './index';
import { menuTheme } from './menu.theme';
import UserProfileMenu from './user-profile-menu';

export const MENU_WIDTH = 56;

const useStyles = makeStyles(() =>
  createStyles({
    root: {
      '& .operations-hub-MuiDrawer-paperAnchorDockedLeft': {
        borderRight: 'none',
      },
      width: MENU_WIDTH,
      flexShrink: 0,
      '& .MuiList-padding': {
        paddingTop: 0,
        paddingBottom: 0,
      },
      '& .MuiList-root': {
        marginTop: '10px',
        display: 'flex',
        flexDirection: 'column',
        height: '90%',
      },
      '& .MuiPaper-root': {
        overflowX: 'hidden',
        width: MENU_WIDTH,
        backgroundColor: menuTheme.colors.menu,
      },
      '& .MuiListItemIcon-root': {
        color: `${menuTheme.colors.menuIcon}`,
        padding: '12px 0',
      },
      '& .MuiListItem-root': {
        padding: 0,
        '& .Mui-selected': {
          backgroundColor: `${menuTheme.colors.menuSelected}`,
          '&:hover': {
            backgroundColor: `${menuTheme.colors.menuSelectedHover}`,
          },
        },
      },
      '& .MuiListItem-gutters': {
        paddingLeft: 0,
      },
    },
    logo: {
      height: '35px',
      width: '35px',
      margin: '16px auto 0 auto',
    },
    productName: {
      color: menuTheme.colors.menuFont,
      fontSize: menuTheme.font.menuSize,
      fontFamily: menuTheme.font.menuFamily,
    },
  }),
);

const NavMenu = (): JSX.Element | null => {
  const classes = useStyles();
  const { hingeHealthAuthState } = useHingeHealthSecurityContext();
  const adminRoles = hingeHealthAuthState?.accessToken?.claims.roles;
  const { routes: roleRoutes, showMenu } = getRoleProperties(adminRoles);
  const routes = useSplitEnabledRoutes(roleRoutes);

  const navMenu = (
    <Box className={classes.root}>
      <Drawer variant="permanent">
        <HHLogo className={classes.logo} />
        <List>
          <ListItem
            style={{
              color: `${menuTheme.colors.menuFont}`,
              paddingLeft: '1em',
            }}
          >
            <HHTypography hhVariant="overline" fontSize={'6'}>
              Ops Hub
            </HHTypography>
          </ListItem>
          {routes.map((route: RouteDetails) => (
            <MenuItem key={route.path} route={route} />
          ))}
          <ListItem
            style={{
              flexGrow: '3',
              alignItems: 'end',
              justifyContent: 'center',
            }}
          >
            <UserProfileMenu />
          </ListItem>
        </List>
      </Drawer>
    </Box>
  );

  return showMenu ? navMenu : null;
};

export default NavMenu;
